import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'seamless-immutable';
import { always } from 'ramda';
import cc from 'classcat';

import { customThemes } from '../../lib/themes';
import { selectField } from '../../lib/contentful/selectors';
import Link from '../Link';

import { enhance } from './enhancers';
import styles from './styles.module.scss';

export const BUTTON_THEMES = Immutable(
  customThemes(['membership', 'transparent', 'transparentDark', 'none'])
);

export const BUTTON_VARIANTS = Immutable(['primary', 'secondary']);

function Button({
  to,
  link,
  onClick,
  redirect,
  replace, // alias of `redirect`
  type,
  disabled,
  theme,
  currentProduct,
  complement,
  inverted,
  variant,
  border,
  id,
  className,
  handleDisabledClick,
  handleClick,
  name,
  children = [],
  style,
  target,
}) {
  let element = Link;
  const themeToUse = selectField('theme')(link) || theme || currentProduct;
  const props = {
    name,
    disabled,
    style,
    onClick: disabled ? handleDisabledClick : onClick,
    className:
      themeToUse == 'none'
        ? className
        : cc([
            styles[themeToUse],
            styles[variant],
            styles.container,
            {
              [styles.border]: border,
              [styles.inverted]: inverted,
              [styles.disabled]: disabled,
              [styles.complement]: complement,
            },
            className,
          ]),
    id,
  };

  if (link || to) {
    Object.assign(props, {
      to,
      link,
      replace,
      redirect,
      onClick,
      theme: 'none',
      target,
    });
  } else if (onClick || type) {
    element = 'button';
    Object.assign(props, { onClick: handleClick, type });
  }

  return React.createElement(element, props, children);
}

Button.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  link: PropTypes.shape({
    link: PropTypes.string,
    label: PropTypes.string,
    id: PropTypes.string,
    theme: PropTypes.oneOf(BUTTON_THEMES),
  }),
  redirect: PropTypes.bool,
  replace: PropTypes.bool, // alias of `redirect`
  theme: PropTypes.oneOf(BUTTON_THEMES),
  variant: PropTypes.oneOf(BUTTON_VARIANTS),
  border: PropTypes.bool,
  complement: PropTypes.bool,
  inverted: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

Button.defaultProps = {
  theme: 'waybetter',
  variant: 'primary',
  border: false,
  complement: false,
  inverted: false,
  onClick: always(undefined),
};

export default enhance(Button);
